import moment from "moment"

export const getPollMaxEndDate = (publishPostAt?: Date | null) =>
    moment(publishPostAt ?? new Date())
        .add(14, "days")
        .toDate()
